import React, { useState } from 'react';
import IForm from '../../../../types/IForm';
import { AttachedFilesBaseUploadFormTemplate } from '../../AttachedFilesBase';
import { PostsEditor } from './PostsEditor';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostTypes } from '../Post.types';
import { InputType } from '../../../../components/molecules/Form';

export type PostsEditorWithUpload = {
  form: IForm;
  type: PostTypes;
  postId?: string;
  autoFocus?: boolean;
};

/**
 * Multi Service request from backend, so this form is from different services.
 * Need to flat the InputType File param, so our fileUpload component can handle this.
 */
const adjustFormForFileUpload = (form: IForm): IForm => {
  const attachedFileUploadParam = form.params?.find(p => p.type === 'filesupload');
  const fileDataParam = attachedFileUploadParam?.params?.find(p => p.type === InputType.FILE);

  if (fileDataParam && form.params?.every(p => p.type !== InputType.FILE)) {
    form.params?.push(fileDataParam);
  }
  return form;
};

/**
 * Wrapper for the Posts RichText Editor with Upload
 */
export function PostsEditorWithUpload({ form, type, postId, autoFocus }: PostsEditorWithUpload) {
  const { t } = useSonTranslation('Posts');

  const [adjustedForm] = useState(adjustFormForFileUpload(form));
  const id = postId ? `posts-${type}-attached-file-form-${postId}` : `posts-${type}-attached-file-form`;

  return (
    <PostsEditor form={{ ...adjustedForm, url: form.url }} type={type} autoFocus={autoFocus}>
      <AttachedFilesBaseUploadFormTemplate
        id={id}
        multiple
        headline={t('default.attachedfiles.headline.selected')}
        hierarchy={4}
      />
    </PostsEditor>
  );
}
